export default {
  "en": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Change Logo (png required)"
      },
      "picture_logo_format": {
        "round": "Round Logo",
        "square": "Square Logo"
      }
    }
  }
}